const breakPoint = 750;

let windowWidth  = window.innerWidth;

let headerBar         = document.getElementById('js-Header--Bar');
let headerMenu        = document.getElementById('js-Header--Menu');
let headerButtonOpen  = document.getElementById('js-Header_Button_Open');
let headerButtonClose = document.getElementById('js-Header_Button_Close');


// ------------------------------------------------------------------------
// headerVisible
// -> SP ヘッダー出現
// ------------------------------------------------------------------------
// const headerVisible = () => {
  // if(windowWidth < breakPoint){
  //   window.addEventListener('scroll', () => {
  //     let scrollGoal   = windowWidth * 0.8;
  //     let scrollVolume = window.pageYOffset;
  //     if(scrollVolume > scrollGoal){
  //       headerBar.classList.remove('st-Header--Bar-Hidden');
  //     } else {
  //       headerBar.classList.add('st-Header--Bar-Hidden');
  //     }
  //   }, false);
  // }
// }


// ------------------------------------------------------------------------
// headerToggle
// -> SP ヘッダー開閉
// ------------------------------------------------------------------------
const headerToggle = () => {
  let headerStatus = false;
  window.addEventListener('load', () => {
    headerButtonOpen.addEventListener('click', () => {
      if(!headerStatus){
        headerBar.classList.add('st-Header--Bar-Hidden');
        headerMenu.classList.remove('st-Header--Menu-Hidden');
        headerStatus = true;
      }
    }, false);
    headerButtonClose.addEventListener('click', () => {
      if(headerStatus){
        headerBar.classList.remove('st-Header--Bar-Hidden');
        headerMenu.classList.add('st-Header--Menu-Hidden');
        headerStatus = false;
      }
    }, false);
  }, false);
}



// ------------------------------------------------------------------------
// newsTile
// -> NEWSタイトル 高さ調整
// ------------------------------------------------------------------------
const newsTile = () => {
  window.addEventListener('load', () => {
    if(windowWidth > breakPoint) {
      $('.js-News_Title').tile(3);
    } else {
      $('.js-News_Title').tile();
    }
  }, false);
  window.addEventListener('resize', () => {
    let resizeWidth = window.innerWidth;
    if(resizeWidth > breakPoint) {
      $('.js-News_Title').tile(3);
    } else {
      $('.js-News_Title').tile();
    }
  }, false);
}



// ------------------------------------------------------------------------
// artistTile
// -> ARTIST名前 高さ調整
// ------------------------------------------------------------------------
const artistTile = () => {
  window.addEventListener('load', () => {
    $('.js-Artist').tile();
    $('.js-Artist_Name').tile();
  }, false);
  window.addEventListener('resize', () => {
    $('.js-Artist').tile();
    $('.js-Artist_Name').tile();
  }, false);
}



// ------------------------------------------------------------------------
// discographyTile
// -> DISCOGRAPHY CDタイトル 高さ調整
// ------------------------------------------------------------------------
const discographyTile = (targetClass) => {
  window.addEventListener('load', () => {
    if(windowWidth > breakPoint) {
      $(targetClass).tile(4);
    } else {
      $(targetClass).tile(2);
    }
  }, false);
  window.addEventListener('resize', () => {
    let resizeWidth = window.innerWidth;
    if(resizeWidth > breakPoint) {
      $(targetClass).tile(4);
    } else {
      $(targetClass).tile(2);
    }
  }, false);
}



// ------------------------------------------------------------------------
// anchorLink
// -> リンク
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    let linkSpeed = 800;
    let linkHref = $(this).attr("href");
    let linkHeight = 0;
    if(windowWidth < breakPoint){
      linkHeight = windowWidth * 0.21;
    }
    let linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top - linkHeight;
    $("html, body").animate({scrollTop: linkPosition}, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// export
// ------------------------------------------------------------------------
export {
  // headerVisible,
  headerToggle,
  newsTile,
  artistTile,
  discographyTile,
  anchorLink
}



// WEBPACK FOOTER //
// module.js